/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { isEmpty } from "lodash";
import { deleteProducts } from "../../../apis/companies/products";
import ItemDetail from "./Item";
import { ITEM_SEARCH_OPTIONS } from "../../../constants/ITEM";
import systemAlert from "../../../utils/systemAlert";

const ItemList = (props) => {
  const {
    useFormItem,
    permission,
    detailOpen,
    setDetailOpen,
    submit
  } = props

  const [fields] = useState([
    { title: "품목분류", key: "category" },
    { title: "품목명", key: "name" },
    { title: "품목코드", key: "code" },
    { title: "규격", key: "size" },
    { title: "구분", key: "division" },
    { title: "단위", key: "unit" },
    { title: "매입단가", key: "buyPrice", type: "comma" },
    { title: "판매단가", key: "sellPrice", type: "comma" },
    { title: "재고수량", key: 'qty' },
    { title: "메모", key: "memo" },
  ]);

  const [selectedItem, setSelectedItem] = useState(null);

  const filters = [
    {
      title: "품목분류 선택",
      type: "select",
      key: "searchType",
      options: {
        list: ITEM_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ];

  const buttons = [
    {
      label: "삭제",
      color: "gray-line",
      action: () => {
        const data = {
          productIdxes: useFormItem.selectedList.map(({ idx }) => idx),
        };

        systemAlert(`선택된 ${useFormItem.selectedList.length}개의 품목을 삭제하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '삭제',
              onClick: () => {

                deleteProducts(data)
                  .then(() => {
                    submit();
                  })
                  .catch((err) => {
                    console.error(err.response);
                  });
              }
            }
          ]
        })
      },
      isDisabled: isEmpty(useFormItem.selectedList),
    },
  ];

  const openDetail = (data, e) => {
    setDetailOpen(true)
    setSelectedItem(data)
  }


  return (
    !isEmpty(permission) && (
      <>
        <Filters
          filters={filters}
          submit={useFormItem.filterSubmit}
          form={useFormItem.form}
          onChange={useFormItem.handleOnChange}
        />
        <ControlTable
          fields={fields}
          list={useFormItem.list}
          buttons={permission.level > 1 ? buttons : []}
          selectedList={useFormItem.selectedList}
          setSelected={useFormItem.setSelectedList}
          isLoading={useFormItem.isLoading}
          total={useFormItem.total}
          page={useFormItem.page}
          setPage={useFormItem.setPage}
          limit={useFormItem.limit}
          setLimit={useFormItem.setLimit}
          isControl={permission.level > 1}
          onSelect={openDetail}
          submit={useFormItem.handleSubmit}
        />
        <ItemDetail
          permission={permission}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={useFormItem.filterSubmit}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </>
    ));
};

export default ItemList;
